<template>
  <div style="background-color: white" v-if="page_loading" class="p-4">
    <loader />
  </div>
  <div v-if="!page_loading" class="p-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="text-2xl font-bold">Insurance Settings</h2>
      <button class="btn btn-primary" @click="showAddModal = true">
        ➕ Add Insurance Company
      </button>
    </div>

    <table class="table table-striped table-bordered shadow-sm">
      <thead class="thead-dark">
        <tr>
          <th>#</th>
          <th>Company Name</th>
          <th>Contact Email</th>
          <th>Phone</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="companies.length === 0">
          <td colspan="5" class="text-center text-muted py-4">
            📭 No insurance companies found.
          </td>
        </tr>
        <tr v-else v-for="(company, index) in companies" :key="company.id">
          <td>{{ index + 1 }}</td>
          <td>
            <a href="#" @click="goToSettings(company.id)" class="text-primary">
              ⚙️ {{ company.name }}
            </a>
          </td>
          <td>{{ company.email }}</td>
          <td>{{ company.phone }}</td>
          <td>
            <!-- <button
              class="btn btn-sm btn-warning mr-2"
              @click="editCompany(company)"
            >
              ✏️ Edit
            </button> -->
            <button
              class="btn btn-sm btn-danger"
              @click="deleteCompany(company.id)"
            >
              🗑️ Delete
            </button>
          </td>
        </tr>
      </tbody>
      <!-- <tbody>
        <tr v-for="(company, index) in companies" :key="company.id">
          <td>{{ index + 1 }}</td>
          <td>
            <a href="#" @click="goToSettings(company.id)" class="text-primary">
              ⚙️ {{ company.name }}
            </a>
          </td>
          <td>{{ company.email }}</td>
          <td>{{ company.phone }}</td>
          <td>
            <button
              class="btn btn-sm btn-warning mr-2"
              @click="editCompany(company)"
            >
              ✏️ Edit
            </button>
            <button
              class="btn btn-sm btn-danger"
              @click="deleteCompany(company.id)"
            >
              🗑️ Delete
            </button>
          </td>
        </tr>
      </tbody> -->
    </table>

    <!-- Add Company Modal -->
    <div
      class="modal fade"
      tabindex="-1"
      :class="{ show: showAddModal }"
      style="display: block"
      v-if="showAddModal"
    >
      <div class="modal-dialog">
        <div
          style="background-color: white"
          v-if="modal_loading"
          class="modal-content"
        >
          <loader />
        </div>
        <div v-if="!modal_loading" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add Insurance Company</h5>
            <button type="button" class="close" @click="showAddModal = false">
              &times;
            </button>
          </div>

          <div class="modal-body">
            <div class="form-group">
              <label>Company Name</label>
              <input
                type="text"
                class="form-control"
                v-model="newCompany.name"
              />
            </div>
            <div class="form-group">
              <label>Contact Email</label>
              <input
                type="email"
                class="form-control"
                v-model="newCompany.email"
              />
            </div>
            <div class="form-group">
              <label>Phone</label>
              <input
                type="text"
                class="form-control"
                v-model="newCompany.phone"
              />
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showAddModal = false">
              Close
            </button>
            <button class="btn btn-primary" @click="saveCompany">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import loader from "../../special_clinics/dialysis/loader.vue";
export default {
  data() {
    return {
      page_loading: false,
      modal_loading: false,
      showAddModal: false,
      companies: [],
      newCompany: {
        name: "",
        email: "",
        phone: "",
      },
    };
  },
  components: {
    loader,
  },
  methods: {
    goToSettings(company) {
      //   location.reload('scheme_settings/' + company.name);
      window.location.href = "/setting/scheme_settings/" + company;
    },
    editCompany(company) {
      alert("Editing: " + company.name);
    },
    // deleteCompany(id) {
    //   this.companies = this.companies.filter((c) => c.id !== id);
    // },
    async deleteCompany(id) {
      if (confirm("Are you sure you want to delete this insurance company?")) {
        this.page_loading = true;
        await generalApiRequest(
          "insurance/org-insurance_delete/" + id,
          "POST",
          this.newCompany,
          1
        );
        // this.page_loading = false;
        this.get_companies();
      }
    },
    async saveCompany() {
      if (this.newCompany.name.trim() === "") return alert("Name required");
      this.modal_loading = true;
      await generalApiRequest(
        "insurance/org-insurance",
        "POST",
        this.newCompany,
        1
      );
      this.get_companies();
      this.modal_loading = false;
      this.showAddModal = false;
      this.newCompany = {
        name: "",
        email: "",
        phone: "",
      };
    },
    async get_companies() {
      this.page_loading = true;
      const response = await generalApiRequest(
        "insurance/org-insurance",
        "GET",
        {},
        1
      );
      console.log(response);
      this.companies = response;
      this.page_loading = false;
    },
  },

  mounted() {
    this.get_companies();
  },
};
</script>

<style>
.table a:hover {
  text-decoration: underline;
}
.modal.fade {
  background: rgba(0, 0, 0, 0.5);
}
</style>
